import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import service from './service'

Vue.config.productionTip = false
// 挂载到Vue原型上
Vue.prototype.$axios = axios // 原始axios
Vue.prototype.$service = service // 封装后的axios
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
